import { Row } from 'src/types'

export function getValueObjectByPath(
  object: Row | undefined,
  path: string
): Row | string | undefined {
  if (!object || !path) {
    return undefined
  }

  const keys = path.split('.')
  let value: Row | string | undefined = object

  for (const key of keys) {
    if (value === null || value === undefined || typeof value !== 'object') {
      return undefined
    }

    if (!Object.prototype.hasOwnProperty.call(value, key)) {
      return undefined
    }

    value = value[key]
  }

  return value
}
